export const EntityId = {
  SUNPHARMA: 1039375,
  SUNPHARMA_OPD_DEMO: 11310642,
  WIPRO_PROD: 1006778,
  WIPRO_STAGING: 11189525,
  WIPRO_TESTING: 11186752,
  WIPRO_DEMO: 11317947,
  NESTLE_DEMO: 11197446,
  NESTLE_INDIA: 11174925,
  NESTLE_BUSINESS: 11237250,
  ADOBE: 1005798,
};

export const WIPRO_ENTITY_ID_LIST = [
  EntityId.WIPRO_PROD,
  EntityId.WIPRO_STAGING,
  EntityId.WIPRO_TESTING,
  EntityId.WIPRO_DEMO,
];

export const NESTLE_ENTITY_ID_LIST = [
  EntityId.NESTLE_DEMO,
  EntityId.NESTLE_INDIA,
  EntityId.NESTLE_BUSINESS,
];

export const ADOBE_ENTITY_ID_LIST = [EntityId.ADOBE];

export const EntityIdBasedCustomConfig = {
  rawFileUploadEntityId: [EntityId.SUNPHARMA],
  multipleBillUploadEntityId: [
    EntityId.SUNPHARMA,
    EntityId.SUNPHARMA_OPD_DEMO,
    EntityId.WIPRO_PROD,
    EntityId.WIPRO_STAGING,
    EntityId.WIPRO_TESTING,
    EntityId.WIPRO_DEMO,
  ],
};

export const SNOWPLOW_EVENTS_SCHEMA = {
  HOME_SCREEN_REIM_CLICK:
    "iglu:com.medibuddy/HOME_SCREEN_REIM_CLICK/jsonschema/2-0-0",
  MB_REIM_HOMEPAGE_LANDED:
    "iglu:com.medibuddy/MB_REIM_HOMEPAGE_LANDED/jsonschema/2-0-0",
  MB_REIM_CREATE_CLAIM:
    "iglu:com.medibuddy/MB_REIM_CREATE_CLAIM/jsonschema/2-0-0",
  MB_REIM_USER_DETAILS_NEXT:
    "iglu:com.medibuddy/MB_REIM_USER_DETAILS_NEXT/jsonschema/2-0-0",
  MB_REIM_SAVE_BILL: "iglu:com.medibuddy/MB_REIM_SAVE_BILL/jsonschema/2-0-0",
  MB_REIM_SUBMIT_CLAIM:
    "iglu:com.medibuddy/MB_REIM_SUBMIT_CLAIM/jsonschema/2-0-0",
  MB_REIM_UPLOAD_BILL_CLICK:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_BILL_CLICK/jsonschema/2-0-0",
  MB_REIM_UPLOAD_RX_CLICK:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_RX_CLICK/jsonschema/2-0-0",
  MB_REIM_UPLOAD_REPORT_CLICK:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_REPORT_CLICK/jsonschema/2-0-0",
  MB_REIM_UPLOAD_BILL_SUCCESS:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_BILL_SUCCESS/jsonschema/2-0-0",
  MB_REIM_UPLOAD_RX_SUCCESS:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_RX_SUCCESS/jsonschema/2-0-0",
  MB_REIM_UPLOAD_REPORT_SUCCESS:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_REPORT_SUCCESS/jsonschema/2-0-0",
  MB_REIM_YOUR_CLAIMS_CLICK:
    "iglu:com.medibuddy/MB_REIM_YOUR_CLAIMS_CLICK/jsonschema/2-0-0",
  MB_REIM_HOME_BANNER:
    "iglu:com.medibuddy/MB_REIM_HOME_BANNER/jsonschema/2-0-0",
  MB_REIM_CLAIM_BANNER:
    "iglu:com.medibuddy/MB_REIM_CLAIM_BANNER/jsonschema/2-0-0",
  MB_REIM_UPLOAD_BILL_FAIL:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_BILL_FAIL/jsonschema/2-0-0",
  MB_REIM_UPLOAD_RX_FAIL:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_RX_FAIL/jsonschema/2-0-0",
  MB_REIM_UPLOAD_REPORT_FAIL:
    "iglu:com.medibuddy/MB_REIM_UPLOAD_REPORT_FAIL/jsonschema/2-0-0",
  REIMBURSEMENT_RESUBMIT_BILL_SAVE_CLICKS:
    "iglu:com.medibuddy/Reimbursement_Resubmit_Bill_Save_Clicks/jsonschema/1-0-0",
  REIMBURSEMENT_RESUBMIT_CLAIM_SAVE_CLICKS:
    "iglu:com.medibuddy/Reimbursement_Resubmit_Claim_Save_Clicks/jsonschema/1-0-0",
  REIMBURSEMENT_LOGIN_POP_ISSUE:
    "iglu:com.medibuddy/REIMBURSEMENT_LOGIN_POP_ISSUE/jsonschema/1-0-1",
};

export const OPDConfig = {
  Old_Policy_EntityPolicyId: 1,
  Old_Policy_SubscriptionId: 1,
};

export const DocumentType = Object.freeze({
  BILL_INVOICE: "Bill_Invoice",
  PRESCRIPTION: "Prescription",
  LAB_REPORT: "LabReport",
});

export const HIDE_BENEFITS_SECTIONS_ENTITY_ID_LIST = [
  11333572
];
export const PRESCRIPTION_QUESTION_ENTITY_ID_LIST = [
  EntityId.NESTLE_DEMO,
  EntityId.NESTLE_INDIA,
  EntityId.NESTLE_BUSINESS,
];

export const ScreenName = {
  HOMEPAGE: "Reimbursement Home Page",
  CREATE_CLAIM: "Create Claim page",
  USER_DETAILS_NEXT: "User Details Next page",
  SUMMARY: "Reimbursement Summary page",
  YOUR_CLAIMS: "Your Claims page",
  INFORMATION_REQUIRED: "Information Required page",
}

export const ACCESSIBILITY_LABELS = {
  NAVIGATION: {
    GO_BACK: "Go back",
    REIMBURSEMENT_NAV: "Reimbursement navigation",
    MEDIBUDDY_LOGO: "Medibuddy Logo",
  },
  
  POLICY: {
    SELECT_POLICY: (selectedPolicy, policiesCount) => 
      `Select policy. Currently selected: ${selectedPolicy || "None"}. ${policiesCount} ${policiesCount === 1 ? "policy" : "policies"} available`,
    AVAILABLE_POLICIES: "Available policies",
    POLICY_OPTION: (policyName, isSelected) => 
      `${policyName}${isSelected ? ", currently selected" : ""}`,
    POLICY_WITH_DESC: (policyLabel, policyDesc, isSelected) => 
      `${policyLabel}${policyDesc ? ", " + policyDesc : ""}${isSelected ? ", currently selected" : ""}`,
    CLOSE_POLICY_SELECTION: "Close policy selection",
    SWITCH_POLICY_MOBILE: (selectedPolicyLabel) =>
      `Select policy. Currently selected: ${selectedPolicyLabel || "None"}. Tap to switch policy`,
  },

  CLAIMS: {
    ALL_CLAIMS_TABLE: (claimCount) => 
      `All Claims table. ${claimCount} claim${claimCount !== 1 ? "s" : ""}. Columns: Claim ID, Patient Name, Status, Claimed amount, Approved amount, Created date. Click on any Claim ID to view full details.`,
    CLAIM_STATUS: (status) => `Claim status: ${status}`,
    CLAIM_ID: (claimId) => `Claim ID: ${claimId}`,
    SORT_BY_DATE: (sortOrder) => 
      `Sort by Created date, currently ${sortOrder === "asc" ? "ascending" : sortOrder === "desc" ? "descending" : "unsorted"}. Press to toggle sort order.`,
    TAP_CLAIM_ID_INFO: "Tap on Claim ID to View Details",
    TIMELINE_STEP: (title) => `Timeline step: ${title}`,
    TIMELINE_DATE: (date) => `Date: ${date}`,
    VIEW_BANK_CHEQUE: "View Bank Cheque Leaf document",
    VIEW_CLAIM_DOCUMENT: (index, isInactive) => 
      `View Claim Document ${index + 1}, ${isInactive ? "Inactive" : "Current"}`,
  },

  TABS: {
    TAB_LABEL: (name, isActive) => `${name}${isActive ? ", currently selected" : ""}`,
    NEED_HELP: (email) => 
      `Need help with Claim? If you have any questions about your OPD claims, email ${email} for support. Our team will get back to you as soon as possible.`,
  },

  BANK_DETAILS: {
    CLOSE_DIALOG: "close",
    BANK_CARD: (bankName, tagLabel, holderName, accountNumber, ifscCode, branchName, isSelected) => 
      `${bankName || "Bank Details"}, ${tagLabel}. Account Holder: ${holderName}. Account Number ending ${accountNumber.slice(-4).split('').join(' ')}. IFSC: ${ifscCode.split('').join(' ')}${branchName ? `. Branch: ${branchName}` : ""}${isSelected ? ". Selected" : ""}`,
    SCROLL_LEFT: "Scroll left to view more bank accounts",
    SCROLL_RIGHT: "Scroll right to view more bank accounts",
    ADD_BANK_ACCOUNT: "Add new bank account",
  },

  SAVED_BILLS: {
    DELETE_DIALOG_TITLE: "delete-dialog-title",
    DELETE_DIALOG_DESC: "delete-dialog-desc",
    CANCEL_DELETE: "Cancel, keep this claim",
    CONFIRM_DELETE: "Yes, delete this claim permanently",
    NO_BILLS_TITLE: "no-bills-title",
    NO_BILLS_DESC: "no-bills-desc",
    BILL_CARD: (index, formName, billNumber, billDate, billAmount) => 
      `Bill ${index + 1}: ${formName}, Bill Number ${billNumber.split('').join(' ')}, Date ${billDate}, Amount ₹${billAmount}`,
    EDIT_BILL: (index) => `Edit bill ${index + 1}`,
    DELETE_BILL: (index) => `Delete bill ${index + 1}`,
  },

  CAROUSEL: {
    BANNER_REGION: (label) => label || "Banner carousel",
  },

  BUTTONS: {
    CLOSE: "Close",
    SUBMIT: "Submit",
    CANCEL: "Cancel",
    DELETE: "Delete",
    EDIT: "Edit",
    ADD: "Add",
  },

  DIALOG: {
    MODAL: "true",
  },

  ROLES: {
    BUTTON: "button",
    TABLIST: "tablist",
    TAB: "tab",
    TABPANEL: "tabpanel",
    LISTBOX: "listbox",
    OPTION: "option",
    RADIOGROUP: "radiogroup",
    RADIO: "radio",
    ARTICLE: "article",
    REGION: "region",
    IMG: "img",
    ALERT: "alert",
  },

  ARIA_LIVE: {
    ASSERTIVE: "assertive",
    POLITE: "polite",
  },

  ARIA_HASPOPUP: {
    DIALOG: "dialog",
    LISTBOX: "listbox",
  },
}

export const WIPRO = "WIPRO";
export const NESTLE = "NESTLE";
export const ADOBE = "ADOBE";
export const TEXT="text";
export const LIST="list";
export const FUNCTION="function";
export const ENTITY_DISCLAIMERS = {
  WIPRO: {
    title: (fiscalYear) => `Key Updates on MAS Policy Changes for FY ${fiscalYear}`,
    contentType: 'list',
    items: [
      "Vision-related expenses (including frames and lenses) will also be covered only through the cashless mode and will not be reimbursable.",
      "Dental - Root canal treatments are covered under Wipro's Group Medical Insurance. Please claim the expenses through your group medical coverage. Any remaining balance can be handled via MAS benefits. Be sure to submit the GMC settlement letter to process the claim.",
      "Medicines - For chronic ailments, a valid prescription issued within 1 year is required. For other ailments, a prescription issued within the last six months is needed. You can also obtain a prescription by using the online consultations available through the MediBuddy platform.",
      {
        text: "Reimbursement is permitted under specific conditions subject to the verification and approval by MediBuddy:",
        subItems: [
          "Vision: For specialized lenses/contact lenses not available with empanelled partners (Lenskart, Specsmakers, Vision Express, Titan, MaxiVision, Dr Agarwal), or when vision partners are unavailable in your area."
        ]
      }
    ],
    footer: "For any questions or clarifications, please reach out to wipro.support@medibuddy.in or call us at +91 9999991555.",
    storageKey: 'masPopupShown'
  },
  NESTLE: {
    title: "Key Notes",
    contentType: 'list',
    items: [
      "Employees are kindly informed that cashless and reimbursement services will now be facilitated through the Medibuddy platform.",
      "You may submit your domiciliary expense claims through the Medibuddy application or portal of medibuddy",
      {
        text: "While filing any reimbursement claim, please ensure the following service-wise requirements are met:",
        subItems: [
          { label: "Pharmacy", text: "A prescription is mandatory for all non-OTC (over-the-counter) medicines." },
          { label: "In-Person Consultation", text: "No prescription is required, only bill will suffice the requirement" },
          { label: "Vision and Dental", text: "No prescription is required, only bill will suffice the requirement" },
          { label: "Lab Tests", text: "Please submit the bill along with the first page of the test report." },
          { label: "Vaccination", text: "Please submit the bill along with the vaccine card or a doctor's certificate." }
        ]
      }
    ],
    storageKey: 'nestleKeyNotesPopupShown'
  },
  ADOBE: {
    title: "Adobe OPD Benefits",
    contentType: 'text',
    content: "The total wallet limit for the entire family (i.e., enrolled beneficiaries) is ₹15,000. You may use this balance for all policy covered benefits.",
    storageKey: 'adobeKeyNotesPopupShown'
  }
};
